import {styled} from "@mui/material";

const AdminLayoutContainer = styled('div')({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});

export default AdminLayoutContainer;
